import { Button } from '@mui/material';
import { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import * as XLSX from 'xlsx';
import { getPOList, getPRList } from '../../api';
import { default as StyledButton } from '../../components/Common/StyledButton';
import { AmountCell } from '../../components/CustomComponents/AmountCell';
import { default as DateFilter } from '../../components/CustomComponents/DateFilter';
import { getClientBranchListReq } from '../../service/branchService';
import { getUserWarehouseListReq } from '../../service/usersService';
import { setBreadcrumbItems } from '../../store/actions';
import MultiSelect from '../DummyTable/MultiSelect';
import SingleSelect from '../DummyTable/SingleSelect';
import Table from '../DummyTable/Table';
import './styles/reports.scss';

const defaultPageSize = 10;
const POStatuses = [
  'draft',
  'published',
  'approved',
  'rejected',
  'sent',
  'accepted',
  'declined',
  'deleted',
];
const PRStatuses = ['draft', 'published', 'approved', 'rejected'];

const ByPRPO = (props) => {
  const { reportType, userType } = props;
  const location = useLocation();
  const isPR = reportType === 'PR';
  const navigate = useNavigate();
  const firstRenderRef = useRef(true);
  const [sorting, setSorting] = useState([{ id: 'createdAt', desc: true }]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: defaultPageSize,
  });

  //fetching the startDate,endDate from the dashboard  
const params = new URLSearchParams(location.search);
const startDate = params.get("startDate");
const endDate = params.get("endDate");

console.log(startDate, endDate);
  const [total, setTotal] = useState(0);
  const [rows, setRows] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [tempStatuses, setTempStatuses] = useState([]);
  const [tempWarehouseId, setTempWarehouseId] = useState(null);
  const [tempBranchId, setTempBranchId] = useState(null);
  const [tempDate, setTempDate] = useState(() => {
  if (startDate && endDate) {
    return {
      start: startDate,
      end: endDate,
    };
  }
  return null;
});
  const [tempSelectedWarehouses, setTempSelectedWarehouses] = useState([]);
  const [selectedWarehouses, setSelectedWarehouses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [warehouseList, setWarehouseList] = useState([]);
  const [warehouseId, setSelectedWarehouseId] = useState(null);

  const [branchList, setBranchList] = useState([]);
  const [branchId, setSelectedBranchId] = useState(null);

  const [date, setDate] = useState(() => {
  if (startDate && endDate) {
    return {
      start: startDate,
      end: endDate,
    };
  }
  return null;
});
  const [isExporting, setExporting] = useState(false);
  const queryAppliedRef = useRef(false);

  const getColumns = (reportType, userType) => {
    const isPR = reportType === 'PR';
    return [
      {
        accessorKey: 'createdAt',
        header: () => <span>{'Date'}</span>,
        enableSorting: true,
        defaultSortIcon: true,
        cell: (value) => (
          <span>
            {new Date(value.getValue()).toLocaleDateString('en-IN', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })}
          </span>
        ),
      },
      {
        accessorKey: isPR ? 'prNumber' : 'poNumber',
        header: () => <span>{isPR ? 'PR Number' : 'PO Number'}</span>,
        enableSorting: true,
        cell: ({ row, getValue }) => {
          const id = row.original?.id;
          const number = getValue();

          return (
            <span
              onClick={() =>
                navigate(
                  isPR
                    ? `/purchase-requisitions/${id}`
                    : `/purchase-orders/${id}`,
                )
              }
              style={{ cursor: 'pointer' }}
            >
              {number || '-'}
            </span>
          );
        },
      },
      userType !== 'client'
        ? {
          accessorKey: 'warehouse',
          header: () => <span>Warehouse</span>,
          enableSorting: true,
          cell: (value) => <span>{value.getValue()}</span>,
        }
        : null,
      {
        accessorKey: isPR ? 'prStatus' : 'poStatus',
        header: () => <span>{isPR ? 'PR Status' : 'PO Status'}</span>,
        cell: ({ getValue }) => {
          const status = getValue()?.toLowerCase() || '-';

          const colorMap = {
            draft: 'gray',
            published: 'goldenrod',
            approved: 'green',
            rejected: 'red',
            sent: 'blue',
            accepted: 'green',
            declined: 'orange',
            deleted: 'red',
          };

          return (
            <span
              style={{ color: colorMap[status] || 'black', fontWeight: 600 }}
            >
              {status.toUpperCase()}
            </span>
          );
        },
      },
      userType !== 'client'
        ? {
          accessorKey: 'clientName',
          header: () => <span>Customer</span>,
          enableSorting: true,
          cell: (value) => <span>{value.getValue()}</span>,
        }
        : null,
      {
        accessorKey: 'shippingBranch',
        header: () => <span>Shipping Branch</span>,
        enableSorting: true,
        cell: (value) => <span>{value.getValue()}</span>,
      },
      {
        accessorKey: 'subtotal',
        header: () => <span>Subtotal</span>,
        cell: ({ getValue }) => <AmountCell value={getValue()} />,
      },
      {
        accessorKey: 'gst',
        header: () => <span>GST</span>,
        cell: ({ getValue }) => <AmountCell value={getValue()} />,
      },
      {
        accessorKey: 'total',
        header: () => <span>{isPR ? 'PR Total' : 'PO Total'}</span>,
        enableSorting: true,
        cell: ({ getValue }) => <AmountCell value={getValue()} />,
      },
      {
        accessorKey: 'createdBy',
        header: () => <span>Created By</span>,
        cell: (value) => <span>{value.getValue() || '-'}</span>,
      },
    ].filter((ele) => ele !== null);
  };

  const parseStatusFromQuery = (search, allowedStatuses) => {
    const params = new URLSearchParams(search);
    const statusParam = params.get('status');
  
    if (!statusParam) return [];
  
    return statusParam
      .split(',')
      .map((s) => s.toLowerCase().trim())
      .filter((s) => allowedStatuses.includes(s));
  };  

  useEffect(() => {
    if (queryAppliedRef.current) return;
  
    const allowedStatuses = reportType === 'PO' ? POStatuses : PRStatuses;
    const parsedStatuses = parseStatusFromQuery(location.search, allowedStatuses);
  
    if (parsedStatuses.length > 0) {
      setTempStatuses(parsedStatuses);
      setStatuses(parsedStatuses);
      resetPagination();
    }
  
    queryAppliedRef.current = true;
  }, [location.search, reportType]);  

  const searchAllWareHouses = async () => {
    try {
      const response = await getUserWarehouseListReq();
      const { warehouses } = response?.payload;
      const list = warehouses.map((wh) => {
        const { _id, name } = wh;
        return {
          id: _id,
          name,
        };
      });
      setWarehouseList(list);
    } catch (error) {
      console.log(error);
    }
  };

  const getBranches = async () => {
    try {
      const response = await getClientBranchListReq();
      const { branches } = response?.payload;
      const list = branches.map((wh) => {
        const { _id, name } = wh;
        return {
          id: _id,
          name,
        };
      });
      setBranchList(list);
    } catch (error) {
      console.log(error);
    }
  };

  const handleApply = () => {
    setStatuses(tempStatuses);
    setSelectedWarehouseId(tempWarehouseId);
    setSelectedBranchId(tempBranchId);
    setDate(tempDate);
    setSelectedWarehouses(tempSelectedWarehouses);
    resetPagination();
  };

  useEffect(() => {
    if (userType === 'admin') {
      searchAllWareHouses();
    }
    if (userType === 'client') {
      getBranches();
    }
  }, []);

  const effectCalled = useRef(false);

  const breadcrumbItems =
    reportType === 'PO'
      ? [
        { title: 'Dashboard', link: '/dashboard' },
        { title: 'By PO', link: '#' },
      ]
      : [
        { title: 'Dashboard', link: '/dashboard' },
        { title: 'By PR', link: '#' },
      ];

  useEffect(() => {
    if (!effectCalled.current) {
      props.setBreadcrumbItems(
        reportType === 'PO' ? 'By PO' : 'By PR',
        breadcrumbItems,
      );
      effectCalled.current = true;
    }
  }, []);
  




  const getPRPOList = async (page, limit) => {
    const sortObj = sorting?.[0];
    const body = {
      page,
      limit,
      status: statuses || [],
      sortField: sortObj?.id || '',
      sortOrder: sortObj?.desc ? 'desc' : 'asc',
      warehouseId: warehouseId || '',
      clientId:
        userType === 'client'
          ? JSON.parse(localStorage.getItem('user')).clientId
          : '',
      branchId: branchId || '',
      warehouseIds:
        selectedWarehouses.length > 0
          ? selectedWarehouses.map((w) => w.id)
          : [],
    };

    if (date?.start && date?.end) {
  body.startDate = date.start;
  body.endDate = date.end;
}
    const res =
      reportType === 'PO' ? await getPOList(body) : await getPRList(body);

    return res;
  };

  useEffect(() => {
    setPagination((p) => ({
      ...p,
      pageIndex: 0,
    }));
  }, [sorting]);

  useEffect(() => {
    if (firstRenderRef.current && statuses.length === 0) {
      firstRenderRef.current = false;
      return;
    }

    const fetchList = async () => {
      try {
        setIsLoading(true);
        const res = await getPRPOList(
          pagination.pageIndex + 1,
          pagination.pageSize,
        );
        if (res.success) {
          const { data, totalCount } = res.payload;
          setRows(data);
          setTotal(totalCount);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchList();
  }, [
    pagination,
    statuses,
    sorting,
    warehouseId,
    branchId,
    date,
    selectedWarehouses,
  ]);

  const columns = useMemo(() => getColumns(reportType, userType), [reportType]);

  const resetPagination = () => {
    setPagination({
      pageIndex: 0,
      pageSize: defaultPageSize,
    });
  };

  const handleStatusChange = (e) => {
    const v = e.target.value;
    setTempStatuses(typeof v === 'string' ? v.split(',') : v);
  };

  const handleWarehouseChange = (e) => {
    setTempWarehouseId(e.target.value);
  };

  const handleBranchChange = (e) => {
    setTempBranchId(e.target.value);
  };

  const resetFilters = () => {
    setSelectedWarehouseId(null);
    setStatuses([]);
    setDate(null);
    setSelectedBranchId(null);
    setSelectedWarehouses([]);
  
    setTempWarehouseId(null);
    setTempStatuses([]);
    setTempDate(null);
    setTempBranchId(null);
    setTempSelectedWarehouses([]);
  
    queryAppliedRef.current = true;
    navigate(location.pathname, { replace: true });
  
    resetPagination();
  };  

  const onDateChange = (data) => {
    setTempDate(data);
  };

  const downloadItemsExcel = async () => {
    try {
      setExporting(true);
      const response = await getPRPOList();

      console.log(response);
      if (response.success) {
        const { data } = response.payload;

        const flatItems = data.map((ele) => ({
          Date: new Date(ele.createdAt).toLocaleString('en-IN', {
            timeZone: 'Asia/Kolkata',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }),
          'PO Number': ele.poNumber || '-',
          'PO Status': ele.poStatus?.toUpperCase() || '-',
          'PR Number': ele.prNumber || '-',
          'PR Status': ele.prStatus?.toUpperCase() || '-',
          Warehouse: ele.warehouse,
          Customer: ele.clientName,
          'Shipping Branch': ele.shippingBranch,
          Subtotal: ele.subtotal,
          GST: ele.gst,
          Total: ele.total,
          'Created By': ele.createdBy,
        }));

        // Convert to worksheet
        const worksheet = XLSX.utils.json_to_sheet(flatItems);

        // Create workbook and add worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'PR_PO');

        // Download as Excel file
        XLSX.writeFile(
          workbook,
          reportType === 'PO'
            ? 'Purchase Order.xlsx'
            : 'Purchase Requisition.xlsx',
        );
        toast.success('PR/PO Exported Successfully!');
        setExporting(false);
      } else {
        console.error('Failed to fetch PR/PO');
        setExporting(false);
      }
    } catch (error) {
      console.error('Error downloading Excel:', error);
      setExporting(false);
    }
  };

  return (
    <div>
      <div className="filter-wrapper">
        <div className="filter-toolbar">
          <div className="filter-row">
            <DateFilter onDateChange={onDateChange} />

            {userType === 'admin' && (
              <SingleSelect
                label="Warehouses"
                list={warehouseList}
                selectedValue={tempWarehouseId}
                handleChange={handleWarehouseChange}
              />
            )}

            {userType === 'client' && (
              <SingleSelect
                label="Branches"
                list={branchList}
                selectedValue={tempBranchId}
                handleChange={handleBranchChange}
              />
            )}

            <MultiSelect
              label="Status"
              list={reportType === 'PO' ? POStatuses : PRStatuses}
              selectedValues={tempStatuses}
              handleChange={handleStatusChange}
            />

            <Button
              variant="contained"
              sx={{ backgroundColor: '#0053FF', height: 40 }}
              onClick={handleApply}
            >
              Apply
            </Button>

            <Button
              variant="outlined"
              sx={{ height: 40 }}
              onClick={resetFilters}
            >
              Reset
            </Button>
          </div>

          <StyledButton
            color="primary"
            className="export-btn"
            onClick={downloadItemsExcel}
            isLoading={isExporting}
          >
            <div className="export-btn-content">
              <i className="ion ion-md-cloud-download mx-2"></i>
              Export
            </div>
          </StyledButton>
        </div>
      </div>
      <Table
        data={rows}
        columns={columns}
        manualPagination
        rowCount={total}
        sorting={sorting}
        pagination={pagination}
        setSorting={setSorting}
        setPagination={setPagination}
        isLoading={isLoading}
      />
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(ByPRPO);
